<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import Layout from '../components/layout/Layout.vue'
import HeroSection from '../components/landing/HeroSection.vue'
import BootAnimation from '../components/animations/BootAnimation.vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const route = useRoute()
const showBootAnimation = ref(true)
const startHeroAnimation = ref(false)

// Clear visited state if coming from a direct navigation (not from menu)
if (!route.meta.fromMenu && window.location.pathname === '/') {
  sessionStorage.removeItem('visited')
}

onMounted(() => {
  const hasVisited = sessionStorage.getItem('visited') === 'true'
  
  if (route.meta.fromMenu || hasVisited) {
    showBootAnimation.value = false
    startHeroAnimation.value = true
  } else {
    showBootAnimation.value = true
    startHeroAnimation.value = false
  }
})

const handleBootComplete = () => {
  showBootAnimation.value = false
  sessionStorage.setItem('visited', 'true')
  startHeroAnimation.value = true
}
</script>

<template>
  <v-app>
    <Layout>
      <BootAnimation
        v-if="showBootAnimation"
        :onAnimationComplete="handleBootComplete"
      />
      <HeroSection 
        v-show="!showBootAnimation" 
        :start-animation="startHeroAnimation" 
      />
      <div class="bottom-links d-none d-md-flex" v-show="!showBootAnimation">
        <a href="https://alterlan.be/privacy" target="_blank" rel="noopener noreferrer" class="nav-link" v-html="t('menu.footerLinks.privacy')"></a>
        <a href="https://alterlan.be/terms" target="_blank" rel="noopener noreferrer" class="nav-link" v-html="t('menu.footerLinks.terms')"></a>
        <router-link to="/contact" class="nav-link" v-html="t('menu.footerLinks.contact')"></router-link>
      </div>
    </Layout>
  </v-app>
</template>

<style scoped>
.bottom-links {
  position: fixed;
  bottom: 2rem;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 4rem;
  z-index: 10;
}

.nav-link {
  color: white;
  min-width: 100px;
  text-align: center;
  text-decoration: none;
  font-size: 0.7rem;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 2px;
  transition: color 0.3s ease;
}

.nav-link:hover {
  color: #e69b71;
}

@media (max-width: 768px) {
  .bottom-links {
    gap: 2rem;
  }

  .nav-link {
    font-size: 0.7rem;
  }
}
</style>
